export const SPEND_CREDITS = '[Balance] spend';
export const EARN_CREDITS = '[Balance] earn';
export const REGISTER_BALANCE_CHANGE = '[Balance] register change';
export const REMOVE_BALANCE_CHANGE = '[Balance] remove change';
